import { blockingFetchService } from "../../lib/blockingFetch"
import { getPercentAmount } from "../../lib/utils"
import apiServerApi from "../../redux/sagas/apiServerApi"

const getBatchPaymentDetails = financierBatch => {

  const { loans } = financierBatch
  if (!loans) return { upfrontTotal: 0, fineractIds: [] }

  let upfrontTotal = 0
  const fineractIds = []
  for (let j = 0; j < loans.length; ++j) {

    const { sellingCost, fineractId, upfrontPercent } = loans[j]

    if (fineractId) {
      upfrontTotal += getPercentAmount(sellingCost, upfrontPercent)
      fineractIds.push(fineractId)
    }
  }

  return { upfrontTotal, fineractIds }
},

getBucketPaymentDetails = financierBucket => {

  const { batches = [] } = financierBucket,
  batchResult = []

  for (let i = 0; i < batches.length; ++i) {

    const { upfrontTotal, fineractIds } = getBatchPaymentDetails(batches[i])
    batchResult.push({
      upfrontTotal,
      fineractIds
    })
  }

  const allUpfrontPayment = batchResult.map(({ upfrontTotal }) =>
    upfrontTotal).reduce((total, upfront) => total + upfront, 0),

  allFineractIds = []
  batchResult.forEach(({ fineractIds }) => allFineractIds.push(...fineractIds))

  return { allUpfrontPayment, allFineractIds }
},

getLoansTotalRepayment = async fineractIds => new Promise((onSuccess, onError) =>
  blockingFetchService(
    accessToken => apiServerApi.loanSummaries(accessToken, fineractIds),
    resp => {

      const data = JSON.parse(resp),
      allTotalRepayment = data.map(({ summary }) => {
        const cc = summary ? JSON.parse(summary) : null
        return cc ? cc.totalRepayment : 0
      }).reduce((total, nb) => total + nb, 0)

      onSuccess(allTotalRepayment)
    },
    error => onError(error)
  )
)

export { getBatchPaymentDetails, getBucketPaymentDetails, getLoansTotalRepayment }



// WEBPACK FOOTER //
// ./src/components/Financiers/financierHelper.js